import { render, staticRenderFns } from "./VBarChart.vue?vue&type=template&id=23decc92&scoped=true&"
import script from "./VBarChart.vue?vue&type=script&lang=js&"
export * from "./VBarChart.vue?vue&type=script&lang=js&"
import style0 from "./VBarChart.vue?vue&type=style&index=0&id=23decc92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23decc92",
  null
  
)

export default component.exports